module.exports = __webpack_public_path__ + "static/img/kportalbg.b6cc86c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/kportalbg.jpg
// module id = 0GyS
// module chunks = 1